import { FaCar, FaExchangeAlt, FaFileAlt, FaLock, FaMoneyBill, FaMoneyCheck, FaShoppingCart, FaSyncAlt, FaUnlock, FaShieldAlt } from "react-icons/fa";
import debounce from "lodash/debounce";
import { toast } from "react-toastify";
import axios, { AxiosError } from "axios";
import { ocultarAcoes } from "../../../../services/acesso";
import { crudDe } from "../../../../services/acesso";
import api from "../../../../services/api";
import Listagem from "../../../../components/listagem";
import { useAppSelector } from "../../../../store/hooks";
import ModalForm from "../../../../components/modal-form";
import { useEffect, useState, useCallback, useMemo } from "react";
import { LocaSmartLayout } from "../../../../components/locasmart-layout";
import { useLocation } from "react-router-dom";
import { TipoFormulario, TipoVeiculo } from "../../../../services/constantes";
import { ehPlanoGratuito, estaEmPeriodoDeTeste, obterIdTenent, usuarioTemPermissao } from "../../../../services/seguranca";
import { ApiError, Campo, CoresVeiculo, Veiculo } from "../../../../services/tipos";
import { handleDownloadFile } from "../../../../services/utilitarios";
import { useFiliais } from "../../../../hooks/useFiliais";
import { FipeMarca, FipeModelo, FipeService, consultarPorPlaca } from "../../../../services/veiculoService";
import { confirm } from "../../../../components/confirm";
import { FaMask, FaMoneyBillTransfer, FaSellcast } from "react-icons/fa6";
import ModalImportacao from "../../../../components/modal-importacao";
import ModalSincronizacao from "../../../../components/locasmartcheck/ModalSincronizacao";
import { CAMPOS_VEICULO } from "../../../../services/importacao";

// Badge do estado de bloqueio do veículo, exibido ao lado da placa na listagem.
const badgeBloqueio = (estado?: string) => {
    if (!estado || estado === 'nao_rastreado') return null;
    const cfg: Record<string, { cor: string; texto: string; titulo: string }> = {
        bloqueado: { cor: '#f44336', texto: 'Bloqueado', titulo: 'Motor cortado — bloqueio confirmado pelo rastreador.' },
        enviado: { cor: '#ff9800', texto: 'Bloqueio enviado', titulo: 'Comando enviado — aguardando o rastreador confirmar o corte do motor (o veículo pode estar em movimento ou sem sinal).' },
        desbloqueado: { cor: '#4CAF50', texto: 'Desbloqueado', titulo: 'Motor ativo.' },
    };
    const c = cfg[estado];
    if (!c) return null;
    return (
        <span title={c.titulo} style={{
            display: 'inline-flex', alignItems: 'center',
            backgroundColor: c.cor, color: '#fff', padding: '2px 8px',
            borderRadius: 12, fontSize: 11, fontWeight: 600, whiteSpace: 'nowrap',
        }}>
            {c.texto}
        </span>
    );
};

function VeiculoListagem() {
    const { empresaTemFiliais, filiaisOptions, filialSelecionada, getCampoFilial, getAcaoEmLoteFilial } = useFiliais();
    const [marcas, setMarcas] = useState<FipeMarca[]>([]);
    const [veiculos, setVeiculos] = useState<Veiculo[]>([]);
    const [placasRastreadas, setPlacasRastreadas] = useState<Set<string>>(new Set());
    const [estadosBloqueio, setEstadosBloqueio] = useState<Map<string, string>>(new Map());
    const [modelos, setModelos] = useState<FipeModelo[]>([]);
    const [carregando, setCarregando] = useState<boolean>(false);
    const [exibirFormModal, setExibirFormModal] = useState(false);
    const [token] = useState(useAppSelector(state => state.token));
    const [isSubmiting, setIsSubmiting] = useState<boolean>(false);
    const [imagemRemovida, setImagemRemovida] = useState<boolean>(false);
    const [arquivoRemovido, setArquivoRemovido] = useState<boolean>(false);
    const [realizarConsulta, setRealizarConsulta] = useState<boolean>(true);
    const [carregandoSelect, setCarregandoSelect] = useState<boolean>(false);
    const [modo, setModo] = useState<TipoFormulario>(TipoFormulario.tpNenhum);
    const [tipoVeiculo, setTipoVeiculo] = useState<TipoVeiculo>(TipoVeiculo.tpNenhum);
    const [veiculoSelecionado, setVeiculoSelecionado] = useState<Veiculo>({} as Veiculo);
    const [rowCount, setRowCount] = useState(0);
    const [valorFipe, setValorFipe] = useState<number | null>(null);
    const [marcaSelecionada, setMarcaSelecionada] = useState<string>('');
    const [modeloSelecionado, setModeloSelecionado] = useState<string>('');
    const [entidadeParaAtualizarFipe, setEntidadeParaAtualizarFipe] = useState<any>({});
    const [forcarAtualizacaoFipe, setForcarAtualizacaoFipe] = useState<boolean>(false);
    const [showModalImportacao, setShowModalImportacao] = useState<boolean>(false);
    const [modalSincOpen, setModalSincOpen] = useState<boolean>(false);
    const [consultandoPlaca, setConsultandoPlaca] = useState<boolean>(false);
    const [exibirModalInativar, setExibirModalInativar] = useState(false);
    const [veiculoParaInativar, setVeiculoParaInativar] = useState<Veiculo | null>(null);
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 25,
    });

    const fipeService = useMemo(() => new FipeService(), []);

    const colunas = [
        {
            field: 'imagem',
            filterable: false,
            headerName: '',
            flex: 1,
            hideable: false,
            disableColumnMenu: true,
            sortable: false,
            renderCell: (params: any) => {
                const imagem = params.value;
                if (imagem) {
                    return (
                        <img
                            src={imagem}
                            alt={params.row.modelo}
                            style={{ width: 80, height: 50, objectFit: 'cover', cursor: 'pointer' }}
                        />
                    );
                }
                return null;
            }
        },
        {
            field: 'placa', headerName: 'Placa', flex: 1,
            renderCell: (params: any) => (
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                    <span>{params.value}</span>
                    {badgeBloqueio(estadosBloqueio.get(params.value))}
                </span>
            )
        },
        { field: 'marca', headerName: 'Marca', flex: 1 },
        { field: 'modelo', headerName: 'Modelo', flex: 1 },
        { field: 'ano', headerName: 'Ano', flex: 1 },
        {
            field: 'vencimentoLicenciamento', headerName: 'Venc. Licenciamento', flex: 1, valueGetter: (params: any) => {
                return new Date(params.value);
            },
            renderCell: (params: any) => {
                const date = new Date(params.value);
                if (isNaN(date.getTime())) {
                    return '';
                }
                return date.toLocaleString("pt-BR", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                });
            }
        },

        {
            field: 'status', headerName: 'Status', flex: 1,
            renderCell: (params: any) => {
                let status = params.value;
                let backgroundColor;
                if (Boolean(params.row.vendido)) {
                    backgroundColor = '#9E9E9E';
                    status = "Vendido";
                } else if (Boolean(params.row.roubado)) {
                    backgroundColor = '#212121';
                    status = "Roubado";
                } else if (Boolean(params.row.inativo)) {
                    backgroundColor = '#90A4AE';
                    status = "Inativo";
                } else if (status === 'Em locação') {
                    backgroundColor = '#4CAF50';
                } else {
                    backgroundColor = '#f44336';
                }

                const labelStyle: React.CSSProperties = {
                    backgroundColor,
                    color: 'white',
                    padding: '5px 10px',
                    borderRadius: '5px',
                    fontWeight: 'bold',
                    textAlign: 'center' as 'center',
                };

                return (
                    <span style={labelStyle}>
                        {status}
                    </span>
                );
            },
        },
        {
            field: 'observacaoInativacao', headerName: 'Observação', flex: 1,
            renderCell: (params: any) => {
                if (!params.row.inativo) return '';
                return params.value || '';
            }
        },
        ...(empresaTemFiliais ? [{
            field: 'idFilial', headerName: 'Unidade', flex: 1,
            renderCell: (params: any) => {
                if (!params.value) return '';
                const filial = filiaisOptions.find((f: any) => f.valor === params.value);
                return filial?.label || '';
            }
        }] : []),
    ];

    const pages = [
        {
            titulo: "Identificação",
            campos: ["idFilial", "placa", "tipoVeiculo", "marca", "modelo", "ano", "statusVeiculo"]
        },
        {
            titulo: "Dados",
            campos: ["renavam", "chassi", "hodometro", "vencimentoLicenciamento", "cor"]
        },
        {
            titulo: "Investimento",
            campos: ["valorFipe", "custo", "dataCompra"]
        },
        {
            titulo: "Documentação",
            campos: ["imagem", "documento"]
        }
    ];

    const campoFilial = getCampoFilial({ linha: 0, coluna: 1, largura: 6 });

    const campos: Campo[] = [
        ...(campoFilial ? [campoFilial] : []),
        {
            label: 'Placa', nome: 'placa', required: true, tipo: 'text', largura: 4, coluna: 1, linha: 1, visible: true,
            mascara: '***-****', tudoMaiusculo: true, minimoCaracteres: 8,
            onCampoSair: (valor: any) => {
                if (modo !== TipoFormulario.tpVisualizacao && valor && valor.replace('-', '').trim().length >= 7) {
                    buscarDadosPorPlaca(valor);
                }
            }
        },
        {
            label: 'Tipo Veículo',
            nome: 'tipoVeiculo',
            required: true,
            tipo: 'select',
            largura: 4,
            coluna: 1,
            linha: 2,
            visible: true,
            opcoes: [
                { valor: TipoVeiculo.tpCarro, label: 'Carro' },
                { valor: TipoVeiculo.tpMoto, label: 'Moto' },
                { valor: TipoVeiculo.tpCaminhao, label: 'Caminhão' },
            ],
            onCampoDigitar: debounce((t: any) => {
                setTipoVeiculo(t);
                setMarcas([]);
                setModelos([]);
                if ((modo === TipoFormulario.tpCadastro || modo === TipoFormulario.tpEdicao) && t) {
                    buscarMarcas(t);
                }
            }, 300),
        },
        {
            label: 'Marca',
            nome: 'marca',
            tipo: 'select',
            required: true,
            largura: 8,
            coluna: 2,
            linha: 2,
            visible: true,
            opcoes: marcas.map(m => ({ valor: m.nome, label: m.nome, codigo: m.codigo })),
            carregando: carregandoSelect,
            onCampoDigitar: debounce((m: any) => {
                setMarcaSelecionada(m || '');
                setModeloSelecionado('');
                setModelos([]);
                if ((modo === TipoFormulario.tpCadastro || modo === TipoFormulario.tpEdicao) && m) {
                    buscarModelosPorMarca(m);
                }
            }, 300),
            allowNotFoundValues: true
        },
        {
            label: 'Modelo',
            nome: 'modelo',
            required: true,
            tipo: 'select',
            largura: 9,
            coluna: 1,
            linha: 3,
            visible: true,
            opcoes: modelos.map(m => ({ valor: m.nome, label: m.nome, codigo: m.codigo })),
            carregando: carregandoSelect,
            allowNotFoundValues: true,
            onCampoDigitar: (m: any) => { setModeloSelecionado(m || ''); }
        },
        {
            label: 'Ano', nome: 'ano', required: true, tipo: 'text', largura: 3, coluna: 2, linha: 3, visible: true,
            onCampoSair: (valor: any) => {
                if (valor && tipoVeiculo && marcaSelecionada && modeloSelecionado) {
                    buscarValorFipe(tipoVeiculo, marcaSelecionada, modeloSelecionado, String(valor));
                }
            }
        },
        { label: 'Informações adicionais:', nome: '', required: false, tipo: 'label', largura: 6, coluna: 2, linha: 4, visible: true },
        { label: 'Renavam', nome: 'renavam', required: false, tipo: 'text', largura: 4, coluna: 1, linha: 5, visible: true, tudoMaiusculo: true, minimoCaracteres: 11 },
        { label: 'Chassi', nome: 'chassi', required: false, tipo: 'text', largura: 4, coluna: 2, linha: 5, visible: true, tudoMaiusculo: true, minimoCaracteres: 17 },
        { label: 'Hodômetro', nome: 'hodometro', required: false, tipo: 'number', largura: 4, coluna: 3, linha: 5, visible: true },
        { label: 'Venc. do Licenciamento', nome: 'vencimentoLicenciamento', required: false, tipo: 'date', largura: 4, coluna: 1, linha: 6, visible: true },
        { label: 'Cor', nome: 'cor', required: true, tipo: 'select', largura: 4, coluna: 2, linha: 6, visible: true, opcoes: CoresVeiculo },
        { label: 'Imagem', nome: 'imagem', required: false, tipo: 'image', largura: 6, coluna: 1, linha: 6, visible: true },
        { label: 'Documento', nome: 'documento', required: false, tipo: 'file', largura: 6, coluna: 2, linha: 6, visible: true },
        { label: 'Dados Compra:', nome: '', required: false, tipo: 'label', largura: 12, coluna: 1, linha: 7, visible: true },
        { label: 'Investimento', nome: 'custo', required: false, tipo: 'money', largura: 6, coluna: 1, linha: 8, visible: true },
        { label: 'Valor FIPE', nome: 'valorFipe', required: false, tipo: 'money', largura: 6, coluna: 2, linha: 8, visible: valorFipe !== null, apenasLeitura: true },
        { label: 'Data da Compra', nome: 'dataCompra', required: false, tipo: 'date', largura: 6, coluna: 1, linha: 9, visible: true },
        { label: 'Id', nome: 'id', required: false, tipo: 'text', largura: 4, coluna: 3, linha: 8, visible: false },
        {
            label: 'Status', nome: 'status', required: false, tipo: 'text', largura: 4, coluna: 2, linha: 1,
            visible: modo === TipoFormulario.tpVisualizacao, apenasLeitura: true,
        },
    ];

    const temPermissao = usuarioTemPermissao(token, 'veiculo_visualizar');

    function tratarErro(error: AxiosError<ApiError>) {
        setCarregando(false);
        setCarregandoSelect(false);
        setArquivoRemovido(false);
        setImagemRemovida(false);

        const data = error.response?.data;

        if (data?.errors && typeof data.errors === 'object' && !Array.isArray(data.errors)) {
            const erros = data.errors as Record<string, string[]>;
            Object.keys(erros).forEach(campo => {
                erros[campo].forEach((msg: string) => toast.error(msg));
            });
            return;
        }

        const msg = data?.Mensagem || error.message || 'Erro desconhecido';
        toast.error('Não foi possível continuar a operação Veículos: ' + msg)
    }

    const requisicaoBemSucedida = (response: any) => {
        setRealizarConsulta(true);
        setExibirFormModal(false);
        toast.success('Veículo salvo com sucesso')
    };

    const buscarMarcas = useCallback(async (tpVeiculo: TipoVeiculo) => {
        if (!tpVeiculo) return;

        setCarregandoSelect(true);
        try {
            const marcasData = await fipeService.getMarcas(tpVeiculo);
            setMarcas(marcasData);
        } catch (error) {
            tratarErro(error as AxiosError<ApiError>);
        } finally {
            setCarregandoSelect(false);
        }
    }, [fipeService]);

    const buscarModelosPorMarca = useCallback(async (marcaNome: string) => {
        if (!marcaNome || !tipoVeiculo) return;

        try {
            const marca = marcas.find(m => m.nome.toLowerCase().trim() === marcaNome.toLowerCase().trim());
            if (!marca) return;

            setCarregandoSelect(true);
            const modelosData = await fipeService.getModelos(tipoVeiculo, marca.codigo);
            setModelos(modelosData);
        } catch (error) {
            toast.info('Não conseguirmos localizar os modelos da marca ' + marcaNome + ' no momento. No entanto, você pode digitar o modelo e continuar normalmente')
        } finally {
            setCarregandoSelect(false);
        }
    }, [tipoVeiculo, marcas, fipeService]);

    const parseFipeValor = (valorStr: string): number | null => {
        const limpo = valorStr.replace('R$', '').replace(/\./g, '').replace(',', '.').trim();
        const num = parseFloat(limpo);
        return isNaN(num) ? null : num;
    };

    const atualizarValorFipeNoForm = useCallback((valor: number) => {
        setValorFipe(valor);
        setEntidadeParaAtualizarFipe({ valorFipe: valor });
        setForcarAtualizacaoFipe(true);
    }, []);

    const buscarValorFipe = useCallback(async (tpVeiculo: TipoVeiculo, marcaNome: string, modeloNome: string, anoTexto: string) => {
        if (!tpVeiculo || !marcaNome || !modeloNome || !anoTexto) {
            setValorFipe(null);
            return;
        }

        const marca = marcas.find(m => m.nome.toLowerCase().trim() === marcaNome.toLowerCase().trim());

        if (!marca) { setValorFipe(null); return; }

        const modelo = modelos.find(m => m.nome.toLowerCase().trim() === modeloNome.toLowerCase().trim());

        if (!modelo) { setValorFipe(null); return; }

        setValorFipe(null);

        try {
            const anos = await fipeService.getAnos(tpVeiculo, marca.codigo, modelo.codigo);

            const anoMatch = anos.find(a => a.codigo.startsWith(anoTexto.trim()));
            if (!anoMatch) return;

            const valor = await fipeService.getValor(tpVeiculo, marca.codigo, modelo.codigo, anoMatch.codigo);

            const numerico = parseFipeValor(valor.Valor);
            if (numerico) atualizarValorFipeNoForm(numerico);
        } catch {
            setValorFipe(null);
        }
    }, [marcas, modelos, fipeService, atualizarValorFipeNoForm]);

    const mapearCorVeiculo = (cor: string | undefined): string | undefined => {
        if (!cor) return undefined;
        const mapa: Record<string, string> = {
            'PRATA': 'Prata',
            'PRETO': 'Preto', 'PRETA': 'Preto',
            'BRANCO': 'Branco', 'BRANCA': 'Branco',
            'CINZA': 'Cinza',
            'VERMELHO': 'Vermelho', 'VERMELHA': 'Vermelho',
            'AZUL': 'Azul',
            'VERDE': 'Verde',
            'AMARELO': 'Amarelo', 'AMARELA': 'Amarelo',
            'MARROM': 'Marrom',
            'BEGE': 'Bege',
            'LARANJA': 'Laranja',
            'DOURADO': 'Dourado', 'DOURADA': 'Dourado',
            'ROXO': 'Roxo', 'ROXA': 'Roxo',
            'ROSA': 'Rosa',
            'FANTASIA': 'Fantasia',
        };
        return mapa[cor.toUpperCase().trim()] || undefined;
    };

    const mapearTipoVeiculo = (tipo: string | undefined): TipoVeiculo => {
        if (!tipo) return TipoVeiculo.tpCarro;
        const t = tipo.toLowerCase();
        if (t.includes('moto') || t.includes('ciclomotor') || t.includes('triciclo')) return TipoVeiculo.tpMoto;
        if (t.includes('caminh') || t.includes('reboque') || t.includes('semi-reboque')) return TipoVeiculo.tpCaminhao;
        return TipoVeiculo.tpCarro;
    };

    const buscarDadosPorPlaca = useCallback(async (placa: string) => {
        setConsultandoPlaca(true);
        setCarregandoSelect(true);
        try {
            const resultado = await consultarPorPlaca(placa);

            if (resultado.sucesso && resultado.marca) {
                const tp = mapearTipoVeiculo(resultado.tipoVeiculo);
                setTipoVeiculo(tp);

                // Carregar marcas da FIPE para o select funcionar
                let marcasData: FipeMarca[] = [];
                try {
                    marcasData = await fipeService.getMarcas(tp);
                    setMarcas(marcasData);
                } catch { /* FIPE indisponível */ }

                const updateData: any = { tipoVeiculo: tp };

                // Tentar match de marca com FIPE
                const marcaApi = resultado.marca.toLowerCase().trim();
                const marcaMatch = marcasData.find(m => {
                    const fipe = m.nome.toLowerCase().trim();
                    return fipe === marcaApi || marcaApi.includes(fipe) || fipe.includes(marcaApi);
                });

                let fipeModeloMatch: { nome: string; codigo: string } | undefined;

                if (marcaMatch) {
                    updateData.marca = marcaMatch.nome;
                    setMarcaSelecionada(marcaMatch.nome);

                    try {
                        const modelosData = await fipeService.getModelos(tp, marcaMatch.codigo);
                        setModelos(modelosData);

                        if (resultado.modelo) {
                            const modeloApi = resultado.modelo.toLowerCase().trim();
                            const modeloMatch = modelosData.find(m => {
                                const fipe = m.nome.toLowerCase().trim();
                                return fipe === modeloApi || modeloApi.includes(fipe) || fipe.includes(modeloApi);
                            });

                            if (modeloMatch) {
                                updateData.modelo = modeloMatch.nome;
                                setModeloSelecionado(modeloMatch.nome);
                                fipeModeloMatch = modeloMatch;
                            } else {
                                updateData.modelo = resultado.modelo;
                                setModeloSelecionado(resultado.modelo);
                            }
                        }
                    } catch {
                        if (resultado.modelo) {
                            updateData.modelo = resultado.modelo;
                            setModeloSelecionado(resultado.modelo);
                        }
                    }
                } else {
                    updateData.marca = resultado.marca;
                    setMarcaSelecionada(resultado.marca);
                    if (resultado.modelo) {
                        updateData.modelo = resultado.modelo;
                        setModeloSelecionado(resultado.modelo);
                    }
                }

                const anoTexto = resultado.anoModelo || resultado.ano;
                if (anoTexto) updateData.ano = anoTexto;

                const corMapeada = mapearCorVeiculo(resultado.cor);
                if (corMapeada) updateData.cor = corMapeada;
                if (resultado.chassi) updateData.chassi = resultado.chassi;

                // Usar valor FIPE direto da consulta de placa se disponível
                if (resultado.valorFipe) {
                    updateData.valorFipe = resultado.valorFipe;
                    setValorFipe(resultado.valorFipe);
                } else if (marcaMatch && fipeModeloMatch && anoTexto) {
                    // Buscar valor FIPE via API quando o backend não retornou
                    try {
                        const anos = await fipeService.getAnos(tp, marcaMatch.codigo, fipeModeloMatch.codigo);
                        const anoMatch = anos.find((a: any) => a.codigo.startsWith(String(anoTexto).trim()));
                        if (anoMatch) {
                            const valor = await fipeService.getValor(tp, marcaMatch.codigo, fipeModeloMatch.codigo, anoMatch.codigo);
                            const numerico = parseFipeValor(valor.Valor);
                            if (numerico) {
                                updateData.valorFipe = numerico;
                                setValorFipe(numerico);
                            }
                        }
                    } catch {
                        // FIPE indisponível
                    }
                }

                setEntidadeParaAtualizarFipe(updateData);
                setForcarAtualizacaoFipe(true);
            }
        } catch {
            // Placa não encontrada na API
        }

        // Consultar hodômetro na Agillock (independente da consulta de placa)
        try {
            const idEmpresa = obterIdTenent(token);
            const respOdometro = await api.get(`/AzulMonitor/Odometro/${idEmpresa}/${encodeURIComponent(placa)}`);
            if (respOdometro.data?.encontrado && respOdometro.data?.odometroKm > 0) {
                setEntidadeParaAtualizarFipe((prev: any) => ({ ...prev, hodometro: respOdometro.data.odometroKm }));
                setForcarAtualizacaoFipe(true);
            }
        } catch {
            // Agillock não configurada ou indisponível
        } finally {
            setCarregandoSelect(false);
            setConsultandoPlaca(false);
        }
    }, [fipeService, token]);

    const handleFecharModal = useCallback(() => {
        setExibirFormModal(false);
        if (modo == TipoFormulario.tpEdicao || modo == TipoFormulario.tpCadastro) {
            setRealizarConsulta(true);
        }
    }, []);

    const handleCadastrar = useCallback(() => {
        if (usuarioTemPermissao(token, 'veiculo_novo')) {
            setModo(TipoFormulario.tpCadastro);
            setVeiculoSelecionado({ ...(filialSelecionada ? { idFilial: filialSelecionada } : {}) } as Veiculo);
            setValorFipe(null);
            setMarcaSelecionada('');
            setModeloSelecionado('');
            setExibirFormModal(true);
        } else {
            toast.error('Você não tem permissão para cadastrar um novo veiculo');
        }
    }, [token, filialSelecionada]);

    const handleEditar = useCallback((veiculo: Veiculo) => {
        if (usuarioTemPermissao(token, 'veiculo_editar')) {
            if (veiculo.vendido) {
                toast.error('Não é possível editar um veículo vendido')
                return;
            }
            if (veiculo.roubado) {
                toast.error('Não é possível editar um veículo roubado')
                return;
            }
            setModo(TipoFormulario.tpEdicao);
            setVeiculoSelecionado(veiculo);
            setExibirFormModal(true);
        } else {
            toast.error('Você não tem permissão para editar um veiculo');
        }
    }, [token]);

    const handleExclusao = useCallback(async (veiculo: Veiculo) => {
        if (usuarioTemPermissao(token, 'veiculo_excluir')) {
            setCarregando(true);
            try {
                await api.delete(`/Veiculo/${veiculo.id}`);
                toast.success('Veiculo foi excluído com sucesso');
                setRealizarConsulta(true);
                setCarregando(false);
            } catch (error) {
                tratarErro(error as AxiosError<ApiError>);
            }
        }
    }, [token]);

    const handleVisualizacao = useCallback((veiculo: Veiculo) => {
        if (usuarioTemPermissao(token, 'veiculo_visualizar')) {
            const veiculoComStatus = { ...veiculo };
            if (veiculo.vendido) veiculoComStatus.status = 'Vendido';
            else if (veiculo.roubado) veiculoComStatus.status = 'Roubado';
            else if (veiculo.inativo) veiculoComStatus.status = 'Inativo';
            setVeiculoSelecionado(veiculoComStatus as Veiculo);
            setExibirFormModal(true);
            setModo(TipoFormulario.tpVisualizacao);
        }
    }, [token]);

    const handleShowModal = useCallback(async () => {
        setValorFipe(null);



        if (modo !== TipoFormulario.tpEdicao && modo !== TipoFormulario.tpVisualizacao) return;
        if (!veiculoSelecionado?.tipoVeiculo) return;

        setTipoVeiculo(veiculoSelecionado.tipoVeiculo);
        setMarcaSelecionada(veiculoSelecionado.marca || '');
        setModeloSelecionado(veiculoSelecionado.modelo || '');

        setCarregando(true);
        try {
            const marcasData = await fipeService.getMarcas(veiculoSelecionado.tipoVeiculo);
            setMarcas(marcasData);

            const marca = marcasData.find(m =>
                m.nome.toLowerCase().trim() === veiculoSelecionado.marca?.toLowerCase().trim()
            );

            let modelosData: FipeModelo[] = [];
            if (marca) {
                modelosData = await fipeService.getModelos(veiculoSelecionado.tipoVeiculo, marca.codigo);
                setModelos(modelosData);
            }

            if (marca && veiculoSelecionado.modelo && veiculoSelecionado.ano) {
                const modelo = modelosData.find(m =>
                    m.nome.toLowerCase().trim() === veiculoSelecionado.modelo?.toLowerCase().trim()
                );
                if (modelo) {
                    try {
                        const anos = await fipeService.getAnos(veiculoSelecionado.tipoVeiculo, marca.codigo, modelo.codigo);
                        const anoMatch = anos.find(a => a.codigo.startsWith(String(veiculoSelecionado.ano).trim()));
                        if (anoMatch) {
                            const valor = await fipeService.getValor(veiculoSelecionado.tipoVeiculo, marca.codigo, modelo.codigo, anoMatch.codigo);
                            const numerico = parseFipeValor(valor.Valor);
                            if (numerico) atualizarValorFipeNoForm(numerico);
                        }
                    } catch {
                        // FIPE indisponível — campo simplesmente não aparece
                    }
                }
            }
        } catch (error) {
            tratarErro(error as AxiosError<ApiError>);
        } finally {
            setCarregando(false);
        }
    }, [modo, veiculoSelecionado, fipeService, atualizarValorFipeNoForm]);

    const location = useLocation();

    useEffect(() => {
        if (forcarAtualizacaoFipe) {
            setForcarAtualizacaoFipe(false);
        }
    }, [forcarAtualizacaoFipe]);

    useEffect(() => {
        setRealizarConsulta(true);
    }, [paginationModel, location.search]);

    // Estado de bloqueio por placa (real da Agillock + pendência da Gestão de Risco), para o
    // indicador visual. Também alimenta o set de placas rastreadas (ação "bloqueio remoto").
    const carregarEstadosBloqueio = useCallback(async (lista: any[]) => {
        try {
            const placas = (lista || []).map((v: any) => v.placa).filter(Boolean);
            if (placas.length === 0) { setPlacasRastreadas(new Set()); setEstadosBloqueio(new Map()); return; }
            const res = await api.post(`/VeiculoEstadoBloqueio/${obterIdTenent(token)}`, placas);
            const mapa = new Map<string, string>();
            const rastreadas = new Set<string>();
            (res.data || []).forEach((s: any) => {
                if (s.estado) mapa.set(s.placa, s.estado);
                if (s.rastreada) rastreadas.add(s.placa);
            });
            setEstadosBloqueio(mapa);
            setPlacasRastreadas(rastreadas);
        } catch {
            setPlacasRastreadas(new Set());
            setEstadosBloqueio(new Map());
        }
    }, [token]);

    // Ativa/desativa o opt-in de bloqueio remoto (Gestão de Risco) do veículo.
    const definirBloqueioRemoto = useCallback(async (veiculo: any) => {
        const novo = !veiculo.bloqueioRemotoHabilitado;
        const ok = await confirm(
            novo
                ? `Ativar bloqueio remoto para ${veiculo.placa}? A Gestão de Risco poderá bloquear este veículo por inadimplência.`
                : `Desativar bloqueio remoto para ${veiculo.placa}? A Gestão de Risco deixará de bloqueá-lo.`
        );
        if (!ok) return;
        try {
            await api.put(`/Veiculo/DefinirBloqueioRemoto/${veiculo.id}`, { habilitado: novo });
            toast.success(novo ? 'Bloqueio remoto ativado.' : 'Bloqueio remoto desativado.');
            setRealizarConsulta(true);
        } catch {
            toast.error('Erro ao alterar o bloqueio remoto.');
        }
    }, []);

    useEffect(() => {
        const fetchVeiculoPorEmpresa = async () => {
            if (!temPermissao || !realizarConsulta) return;

            setCarregando(true);
            try {
                const searchParams = new URLSearchParams(location.search);
                const searchTerm = searchParams.get('search') || "";
                const pageToSend = paginationModel.page + 1;
                
                let url = `/VeiculoPorEmpresaComArquivosPaginado/${obterIdTenent(token)}?page=${pageToSend}&pageSize=${paginationModel.pageSize}`;
                
                if (searchTerm) {
                    url += `&termoBusca=${encodeURIComponent(searchTerm)}`;
                }

                const response = await api.get(url);
                const itens = response.data.items ? response.data.items : (response.data || []);
                setVeiculos(itens);
                setRowCount(response.data.items ? response.data.totalCount : (response.data?.length || 0));
                carregarEstadosBloqueio(itens);
                setRealizarConsulta(false);
                setCarregando(false);
            } catch (error) {
                tratarErro(error as AxiosError<ApiError>);
            }
        };

        fetchVeiculoPorEmpresa();
    }, [temPermissao, realizarConsulta, token, paginationModel, location.search]);

    const onSave = useCallback(async (entidade: any) => {
        if (isSubmiting) return;

        setIsSubmiting(true);

        if (!usuarioTemPermissao(token, 'veiculo_novo') && !usuarioTemPermissao(token, 'veiculo_editar')) {
            setIsSubmiting(false);
            return;
        }

        try {
            const veiculo: Veiculo = {
                ano: entidade.ano,
                cor: entidade.cor,
                dataCompra: entidade.dataCompra,
                hodometro: entidade.hodometro,
                idEmpresa: obterIdTenent(token),
                renavam: entidade.renavam || '',
                custo: entidade.custo,
                marca: entidade.marca,
                modelo: entidade.modelo,
                placa: entidade.placa,
                tipoVeiculo: entidade.tipoVeiculo,
                vencimentoLicenciamento: entidade.vencimentoLicenciamento,
                vendido: entidade.vendido || false,
                roubado: entidade.roubado || false,
                inativo: entidade.inativo || false,
                chassi: entidade.chassi,
                ...(entidade.idFilial && { idFilial: entidade.idFilial }),
                ...(modo === TipoFormulario.tpEdicao && { id: entidade.id })
            };

            const dadosASalvar = new FormData();

            Object.entries(veiculo).forEach(([key, value]) => {
                dadosASalvar.append(key, typeof value === 'object' ? JSON.stringify(value) : String(value));
            });

            if (entidade.imagem) dadosASalvar.append("imagem", entidade.imagem);
            if (entidade.documento) dadosASalvar.append("documento", entidade.documento);

            const imgRemoved = imagemRemovida && !entidade.imagem;
            const docRemoved = arquivoRemovido && !entidade.documento;

            dadosASalvar.append("removerImagem", String(imgRemoved));
            dadosASalvar.append("removerDocumento", String(docRemoved));

            const response = await (modo === TipoFormulario.tpCadastro ? api.post : api.put)(
                `/veiculo/`,
                dadosASalvar,
                {
                    headers: { 'Content-Type': 'multipart/form-data' }
                }
            );

            const cascadeCounts = response?.data?.cascadeCounts;

            setTimeout(() => {
                setRealizarConsulta(true);
                setExibirFormModal(false);
                toast.success('Veículo salvo com sucesso');

                if (cascadeCounts && cascadeCounts.total > 0) {
                    const partes: string[] = [];
                    if (cascadeCounts.locacoes) partes.push(`${cascadeCounts.locacoes} locação(ões)`);
                    if (cascadeCounts.pagamentos) partes.push(`${cascadeCounts.pagamentos} pagamento(s)`);
                    if (cascadeCounts.lancamentos) partes.push(`${cascadeCounts.lancamentos} lançamento(s)`);
                    if (cascadeCounts.multas) partes.push(`${cascadeCounts.multas} multa(s)`);
                    if (cascadeCounts.manutencoes) partes.push(`${cascadeCounts.manutencoes} manutenção(ões)`);
                    if (cascadeCounts.trocasOleo) partes.push(`${cascadeCounts.trocasOleo} troca(s) de óleo`);
                    if (cascadeCounts.vistorias) partes.push(`${cascadeCounts.vistorias} vistoria(s)`);
                    toast.info(`Unidade atualizada. Migrados: ${partes.join(', ')}.`);
                }

                setIsSubmiting(false);
                setArquivoRemovido(false);
                setImagemRemovida(false);
            }, 250);
        } catch (error) {
            tratarErro(error as AxiosError<ApiError>);
            setIsSubmiting(false);
        }
    }, [
        isSubmiting,
        token,
        modo,
        imagemRemovida,
        arquivoRemovido
    ]);

    const documentoNaoInformado = () => {
        toast.info('Esse veículo não possui um documento anexado no sistema.');
    }

    const naoFoiPossivelBaixarDocumento = () => {
        toast.error('Não foi possível baixar o documento do veículo.');
    }

    const documentoBaixadoComSucesso = () => {
        toast.success('Documento baixado com sucesso');
    }

    const baixarContrato = async (entidade: any) => {
        handleDownloadFile(entidade.documento, `${entidade.placa}-DOCUMENTO`, () => documentoNaoInformado(), () => documentoBaixadoComSucesso(), () => naoFoiPossivelBaixarDocumento());
    }

    const inativarAtivarVeiculo = async (veiculo: Veiculo) => {
        if (veiculo.vendido) {
            // A venda é definitiva para a locadora: só a plataforma desfaz (DL-181).
            toast.error('Você não pode alterar o status de um veículo vendido. A venda é irreversível; em caso de engano, fale com o suporte.');
            return;
        }
        if (veiculo.roubado) {
            toast.error('Você não pode alterar o status de um veículo roubado.');
            return;
        }
        const vaiInativar = !veiculo.inativo && !veiculo.vendido;
        if (vaiInativar) {
            setVeiculoParaInativar(veiculo);
            setExibirModalInativar(true);
            return;
        }
        setCarregando(true);
        try {
            await api.put(`/Veiculo/MarcarComoAtivo/${veiculo.id}`);
            toast.success('Veículo ativado com sucesso');
            setRealizarConsulta(true);
        } catch (error) {
            tratarErro(error as AxiosError<ApiError>);
        } finally {
            setCarregando(false);
        }
    }

    const confirmarInativacao = async (entidade: any) => {
        if (!veiculoParaInativar) return;
        setCarregando(true);
        try {
            await api.put(`/Veiculo/MarcarComoInativo/${veiculoParaInativar.id}`, {
                observacao: entidade?.observacaoInativacao || null,
            });
            toast.success('Veículo inativado com sucesso');
            setExibirModalInativar(false);
            setVeiculoParaInativar(null);
            setRealizarConsulta(true);
        } catch (error) {
            tratarErro(error as AxiosError<ApiError>);
        } finally {
            setCarregando(false);
        }
    }

    const venderVeiculo = async (veiculo: Veiculo) => {
        if (veiculo.vendido) {
            toast.error('Esse veículo já está marcado como vendido.');
            return;
        }
        
        if (veiculo.status && veiculo.status.toLowerCase() == 'em locação') {
            toast.error('Você não pode alterar o status de veículo que está em uma locação ativa.');
            return;
        }

        if(await confirm("Esta ação é irreversível! O veículo sai da frota e deixa de contar no plano.\nDeseja realmente marcar o veículo como vendido?", { alert: true, waitSeconds: 5, sound: true })) {
            setCarregando(true);
            try {
                await api.put(`/Veiculo/MarcarComoVendido/${veiculo.id}`);
                toast.success(`Veículo vendido com sucesso`);
                setRealizarConsulta(true);
                setCarregando(false);
            } catch (error) {
                tratarErro(error as AxiosError<ApiError>);
            }
        }
    }

    const marcarComoRoubado = async (veiculo: Veiculo) => {
        if (veiculo.roubado) {
            toast.error('Esse veículo já está marcado como roubado.');
            return;
        }
        
        if (veiculo.status && veiculo.status.toLowerCase() == 'em locação') {
            toast.error('Você não pode alterar o status de veículo que está em uma locação ativa.');
            return;
        }

        if(await confirm("Esta ação é irreversível!\nDeseja realmente marcar o veículo como roubado?", { alert: true, waitSeconds: 5, sound: true })) {
            setCarregando(true);
            try {
                await api.put(`/Veiculo/MarcarComoRoubado/${veiculo.id}`);
                toast.success(`Veículo marcado como roubado com sucesso`);
                setRealizarConsulta(true);
                setCarregando(false);
            } catch (error) {
                tratarErro(error as AxiosError<ApiError>);
            }
        }
    }

    const bloquearDesbloquearVeiculo = async (veiculo: Veiculo) => {
        if (!veiculo.placa) {
            toast.error('Veículo sem placa informada.');
            return;
        }

        const acao = await new Promise<string | null>((resolve) => {
            const modal = document.createElement('div');
            modal.style.cssText = 'position:fixed;top:0;left:0;width:100vw;height:100vh;background:rgba(0,0,0,0.5);z-index:99999;display:flex;align-items:center;justify-content:center;';

            const box = document.createElement('div');
            box.style.cssText = 'background:white;border-radius:12px;padding:28px;width:90%;max-width:400px;';
            box.innerHTML = `
                <h3 style="margin:0 0 8px 0;color:#1F467E;font-size:16px;">Bloqueio de Veículo</h3>
                <p style="margin:0 0 16px 0;color:#666;font-size:14px;">Placa: <strong id="placa-label"></strong></p>
                <p style="margin:0 0 16px 0;color:#666;font-size:13px;">Digite sua senha para confirmar a ação:</p>
                <input id="senha-bloqueio" type="password" placeholder="Sua senha" style="width:100%;padding:10px;border:1px solid #ddd;border-radius:6px;margin-bottom:16px;font-size:14px;box-sizing:border-box;" />
                <div id="erro-senha" style="color:#e53935;font-size:13px;margin-bottom:12px;display:none;">Senha incorreta</div>
                <div style="display:flex;gap:10px;justify-content:flex-end;">
                    <button id="btn-cancelar" style="padding:10px 20px;border:1px solid #ddd;border-radius:8px;cursor:pointer;background:#f8f9fa;font-size:14px;">Cancelar</button>
                    <button id="btn-bloquear" style="padding:10px 20px;border:none;border-radius:8px;cursor:pointer;background:#e53935;color:white;font-weight:600;font-size:14px;">Bloquear</button>
                    <button id="btn-desbloquear" style="padding:10px 20px;border:none;border-radius:8px;cursor:pointer;background:#4CAF50;color:white;font-weight:600;font-size:14px;">Desbloquear</button>
                </div>
            `;
            modal.appendChild(box);
            document.body.appendChild(modal);

            const placaLabel = box.querySelector('#placa-label');
            if (placaLabel) placaLabel.textContent = veiculo.placa;

            const inputSenha = box.querySelector('#senha-bloqueio') as HTMLInputElement;
            inputSenha?.focus();

            const cleanup = () => { document.body.removeChild(modal); };

            box.querySelector('#btn-cancelar')?.addEventListener('click', () => { cleanup(); resolve(null); });
            modal.addEventListener('click', (e) => { if (e.target === modal) { cleanup(); resolve(null); } });

            const executar = async (tipo: string) => {
                const senha = inputSenha?.value;
                if (!senha) { inputSenha?.focus(); return; }

                const erroDiv = box.querySelector('#erro-senha') as HTMLElement;

                try {
                    const idEmpresa = obterIdTenent(token);
                    const placaEncoded = encodeURIComponent(veiculo.placa.replace('-', '').toUpperCase());
                    const endpoint = tipo === 'bloquear' ? 'Bloquear' : 'Desbloquear';

                    await api.post(`/AzulMonitor/${endpoint}/${idEmpresa}/${placaEncoded}`, { senha });
                    cleanup();
                    resolve(tipo);
                } catch (error: any) {
                    const data = error.response?.data;
                    const msg = data?.Mensagem || data?.mensagem || data?.message || data?.title || (typeof data === 'string' ? data : null) || 'Erro ao enviar comando';
                    if (msg.toLowerCase().includes('senha')) {
                        if (erroDiv) { erroDiv.style.display = 'block'; erroDiv.textContent = 'Senha incorreta'; }
                        inputSenha.value = '';
                        inputSenha.focus();
                    } else {
                        cleanup();
                        toast.error(msg);
                        resolve(null);
                    }
                }
            };

            box.querySelector('#btn-bloquear')?.addEventListener('click', () => executar('bloquear'));
            box.querySelector('#btn-desbloquear')?.addEventListener('click', () => executar('desbloquear'));
            inputSenha?.addEventListener('keydown', (e) => { if (e.key === 'Escape') { cleanup(); resolve(null); } });
        });

        if (acao === 'bloquear') {
            toast.success('Comando de bloqueio enviado com sucesso!');
        } else if (acao === 'desbloquear') {
            toast.success('Comando de desbloqueio enviado com sucesso!');
        }
    };

    // Ações que a API restringe: situação do veículo exige veiculo_editar; bloquear pelo rastreador exige rastreador_bloquear.
    const podeEditarVeiculo = usuarioTemPermissao(token, 'veiculo_editar');
    const acoesDoVeiculoPermitidas: Record<string, boolean> = {
        'Ativar/Inativar': podeEditarVeiculo,
        'Marcar como vendido': podeEditarVeiculo,
        'Marcar como roubado': podeEditarVeiculo,
        'Ativar/Desativar bloqueio remoto': podeEditarVeiculo,
        'Bloquear/Desbloquear': usuarioTemPermissao(token, 'rastreador_bloquear'),
    };

    return (
        <LocaSmartLayout>
            <Listagem
                    permissoes={crudDe('veiculo')}
                colunas={colunas}
                linhas={veiculos}
                IconeEntidade={FaCar}
                nomeEntidade="Veiculo"
                nomePropriedade="placa"
                carregando={carregando}
                exibirAcoesDeCrud={true}
                handleEditar={handleEditar}
                handleCriar={handleCadastrar}
                handleExclusao={handleExclusao}
                handleVisualizacao={handleVisualizacao}
                handleSelecionarEntidade={setVeiculoSelecionado}
                acoesExtras={ocultarAcoes([{
                    Icone: FaFileAlt, OnClick: (entidade) => {
                        baixarContrato(entidade)
                    }, Texto: 'Baixar Documento'
                }, {
                    Icone: FaExchangeAlt, OnClick: (entidade) => {
                        inativarAtivarVeiculo(entidade)
                    }, Texto: 'Ativar/Inativar'
                }, {
                    Icone: FaMoneyBillTransfer, OnClick: (entidade) => {
                        venderVeiculo(entidade)
                    }, Texto: 'Marcar como vendido'
                }, {
                    Icone: FaMask, OnClick: (entidade) => {
                        marcarComoRoubado(entidade)
                    }, Texto: 'Marcar como roubado'
                }, {
                    Icone: FaLock, OnClick: (entidade) => {
                        bloquearDesbloquearVeiculo(entidade)
                    }, Texto: 'Bloquear/Desbloquear'
                }, {
                    Icone: FaShieldAlt, OnClick: (entidade) => {
                        definirBloqueioRemoto(entidade)
                    }, Texto: 'Ativar/Desativar bloqueio remoto',
                    Condicao: (v: any) => placasRastreadas.has(v?.placa),
                    TooltipDisabled: 'Veículo não integrado à Agillock'
                }], acoesDoVeiculoPermitidas)}
                rowCount={rowCount}
                paginationModel={paginationModel}
                onPaginationModelChange={setPaginationModel}
                paginationMode="server"
                onImportar={() => setShowModalImportacao(true)}
                headerExtra={(
                    <button
                        onClick={() => setModalSincOpen(true)}
                        style={{
                            display: 'flex', alignItems: 'center', gap: 6,
                            padding: '4px 12px', borderRadius: 20,
                            border: '1.5px solid #2e7d32', backgroundColor: '#e8f5e9',
                            cursor: 'pointer', fontSize: 13, fontWeight: 600,
                            color: '#1b5e20', transition: 'all 0.2s',
                        }}
                        onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#c8e6c9'; }}
                        onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#e8f5e9'; }}
                        title="Sincronizar veículos, motoristas e vínculos com o LocaSmartCheck"
                    >
                        <FaSyncAlt size={14} />
                        Sincronizar
                    </button>
                )}
                tituloExportacao="Veiculos"
                onExportarBuscarTudo={async () => {
                    const searchParams = new URLSearchParams(location.search);
                    const searchTerm = searchParams.get('search') || "";
                    // pageSize alto para obter o dataset completo respeitando o termo de busca atual
                    let url = `/VeiculoPorEmpresaComArquivosPaginado/${obterIdTenent(token)}?page=1&pageSize=100000`;
                    if (searchTerm) url += `&termoBusca=${encodeURIComponent(searchTerm)}`;
                    const response = await api.get(url);
                    return response.data?.items ?? response.data ?? [];
                }}
                acoesEmLote={[
                    ...(getAcaoEmLoteFilial('Veiculo', () => setRealizarConsulta(true)) ? [getAcaoEmLoteFilial('Veiculo', () => setRealizarConsulta(true))!] : []),
                ]}
            />

            <ModalSincronizacao
                open={modalSincOpen}
                onClose={() => setModalSincOpen(false)}
            />

            <ModalImportacao
                show={showModalImportacao}
                onHide={() => setShowModalImportacao(false)}
                titulo="Importar Veículos"
                campos={CAMPOS_VEICULO}
                nomeTemplate="template-veiculos"
                camposFixos={{ idEmpresa: obterIdTenent(token), dataCadastro: new Date().toISOString() }}
                enviar={async (item) => {
                    const formData = new FormData();
                    Object.entries(item).forEach(([key, value]) => {
                        if (value !== undefined && value !== null) {
                            formData.append(key, String(value));
                        }
                    });
                    await api.post('/Veiculo', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
                }}
                permitirAtualizacao
                chaveMatch="placa"
                rotuloCampo="placa"
                buscarExistentes={async () => {
                    const resp = await api.get(`/VeiculoPorEmpresa/${obterIdTenent(token)}`);
                    return resp.data || [];
                }}
                atualizar={async (item) => {
                    const formData = new FormData();
                    Object.entries(item).forEach(([key, value]) => {
                        // Só campos escalares — o registro existente traz objetos/arrays (arquivos,
                        // cascade) que não pertencem ao VeiculoDto e quebrariam o multipart.
                        if (value !== undefined && value !== null && typeof value !== 'object') {
                            formData.append(key, String(value));
                        }
                    });
                    await api.put('/Veiculo', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
                }}
                onImportacaoConcluida={() => setRealizarConsulta(true)}
            />

            {consultandoPlaca && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    zIndex: 9999,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backdropFilter: 'blur(4px)',
                }}>
                    <div style={{
                        background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
                        borderRadius: '16px',
                        padding: '40px 48px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: '20px',
                        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.4)',
                        border: '1px solid rgba(255, 255, 255, 0.1)',
                        animation: 'fadeIn 0.3s ease',
                    }}>
                        <div style={{
                            width: '56px',
                            height: '56px',
                            border: '4px solid rgba(255, 255, 255, 0.1)',
                            borderTopColor: '#4fc3f7',
                            borderRadius: '50%',
                            animation: 'spin 0.8s linear infinite',
                        }} />
                        <div style={{ textAlign: 'center' }}>
                            <p style={{
                                color: '#ffffff',
                                fontSize: '18px',
                                fontWeight: 600,
                                margin: '0 0 6px 0',
                                letterSpacing: '0.3px',
                            }}>
                                Consultando placa...
                            </p>
                            <p style={{
                                color: 'rgba(255, 255, 255, 0.5)',
                                fontSize: '13px',
                                margin: 0,
                            }}>
                                Buscando dados do veículo
                            </p>
                        </div>
                        <button
                            onClick={() => setConsultandoPlaca(false)}
                            style={{
                                marginTop: '8px',
                                background: 'transparent',
                                border: '1px solid rgba(255, 255, 255, 0.25)',
                                color: 'rgba(255, 255, 255, 0.7)',
                                padding: '8px 24px',
                                borderRadius: '8px',
                                cursor: 'pointer',
                                fontSize: '13px',
                                transition: 'all 0.2s ease',
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.background = 'rgba(255,255,255,0.1)';
                                e.currentTarget.style.color = '#fff';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.background = 'transparent';
                                e.currentTarget.style.color = 'rgba(255,255,255,0.7)';
                            }}
                        >
                            Inserir Manualmente
                        </button>
                    </div>
                    <style>{`
                        @keyframes spin {
                            to { transform: rotate(360deg); }
                        }
                        @keyframes fadeIn {
                            from { opacity: 0; transform: scale(0.95); }
                            to { opacity: 1; transform: scale(1); }
                        }
                    `}</style>
                </div>
            )}

            <ModalForm
                modo={modo}
                tamanho="lg"
                isSaving={isSubmiting}
                campos={campos}
                onSave={onSave}
                show={exibirFormModal}
                carregando={carregando}
                onShow={handleShowModal}
                onHide={handleFecharModal}
                onCancel={handleFecharModal}
                entidadeSelecionada={veiculoSelecionado}
                atualizacaoEntidade={{
                    entidadeUsadaParaAtualizacao: entidadeParaAtualizarFipe,
                    forcarAtualizacao: forcarAtualizacaoFipe
                }}
                pages={pages}
                apiConfig={{
                    endpoint: "veiculo",
                    requisicaoBemSucedida: requisicaoBemSucedida,
                    tratarErro: tratarErro,
                    idTenentCampo: 'idEmpresa'
                }}
                planoPremium={(!ehPlanoGratuito(token) && !estaEmPeriodoDeTeste(token))}
                onFileRemoved={(campo: string) => {
                    setArquivoRemovido(true);
                }}
                onImageRemoved={(campo: string) => {
                    setImagemRemovida(true);
                }}
            />

            <ModalForm
                modo={TipoFormulario.tpCadastro}
                tamanho="lg"
                titulo="Inativar Veículo"
                tituloBotaoOk="Inativar"
                campos={[
                    { label: 'Observação (opcional)', nome: 'observacaoInativacao', required: false, tipo: 'memo', largura: 12, coluna: 1, linha: 1, visible: true },
                ]}
                onSave={confirmarInativacao}
                show={exibirModalInativar}
                carregando={carregando}
                onHide={() => { setExibirModalInativar(false); setVeiculoParaInativar(null); }}
                onCancel={() => { setExibirModalInativar(false); setVeiculoParaInativar(null); }}
                entidadeSelecionada={{}}
                apiConfig={{
                    endpoint: "Veiculo",
                    requisicaoBemSucedida: () => {},
                    tratarErro: () => {},
                    idTenentCampo: 'idEmpresa',
                }}
            />
        </LocaSmartLayout>
    );
}

export default VeiculoListagem;